import { FC, useState, ChangeEvent } from 'react';
import { useStyles } from './styles';
import { Paper, Tabs, Tab } from '@material-ui/core';
import TabPanel from '../../TabPanel';
import { LDAPCredentials, AdminUserProfile } from './TabsContent';
import { useStore } from 'hooks/useRootStore';

function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}
export const LeftTabsBlock: FC = () => {
  const classes = useStyles();
  const [value, setValue] = useState<string>(localStorage.getItem('selectedTab') || 'one');
  const {
    userStore: { user },
  } = useStore();
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
    localStorage.setItem('selectedTab', newValue);
  };
  return (
    <Paper className={classes.tabsPaper}>
      {user ? (
        <>
          {user.permission === 'SystemAdmin' && (
            <>
              <Tabs
                value={value}
                className={classes.tabs}
                TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
                onChange={handleChange}
              >
                <Tab value='one' wrapped label='Cloud Directory' {...a11yProps('one')} />
                <Tab value='three' wrapped label='ADMIN PROFILE' {...a11yProps('three')} />
              </Tabs>
              <div className={classes.tabBox}>
                <TabPanel value={value} index='one'>
                  <LDAPCredentials />
                </TabPanel>
                <TabPanel value={value} index='three'>
                  <AdminUserProfile />
                </TabPanel>
              </div>
            </>
          )}
          {/* {user.permission === 'billing_admin' && (
            <>
              <Tabs
                value={value}
                className={classes.tabs}
                TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
                onChange={handleChange}
              >
                <Tab value='one' wrapped label='License' {...a11yProps('one')} />
              </Tabs>
              <div className={classes.tabBox}>
                <TabPanel value={value} index='one'>
                  <LicenseSubscription />
                </TabPanel>
              </div>
            </>
          )} */}
          {user.permission === 'ClientAdmin' && (
            <>
              <Tabs
                value={value}
                className={classes.tabs}
                TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
                onChange={handleChange}
              >
                <Tab value='one' wrapped label='Cloud Directory' {...a11yProps('one')} />
                {/* <Tab value='two' wrapped label='License' {...a11yProps('two')} /> */}
                <Tab value='two' wrapped label='ADMIN PROFILE' {...a11yProps('two')} />
              </Tabs>
              <div className={classes.tabBox}>
                <TabPanel value={value} index='one'>
                  <LDAPCredentials />
                </TabPanel>
                {/* <TabPanel value={value} index='two'>
                  <LicenseSubscription />
                </TabPanel> */}
                <TabPanel value={value} index='two'>
                  <AdminUserProfile />
                </TabPanel>
              </div>
            </>
          )}
        </>
      ) : null}
    </Paper>
  );
};
